<template>

    <div class="posts-grid">

        <!-- layout columns -->
        <div v-if="layout === 'columns'" class="flex w-full flex-wrap lg1024:pr-10 xl1920:pr-17">
            <article class="w-full">
                <!-- featured post -->
                <router-link :to="{ name: 'Post', params: { id: favoritePost.id, code: favoritePost.code }}" class="w-full featured-post flex flex-col mt-6 lg1024:mt-10 relative w-full">
                    <LazyImage :classes="['image-container__featured-post']" :imageUrl="`https://ru.coral.club/${favoritePost.previewImageUrl}`" :alt="favoritePost.name"/>
                        <div class="featured-post__heading w-full text-lg sm640:text-xl lg1024:text-2xl xl1280:text-4xl font-bold lg1024:w-2/3" v-html="favoritePost.name"></div>
                        <div class="featured-post__credentials-container w-full hidden md768:block">
                            <div class="featured-post__credentials flex justify-between w-full border-t-2 border-gray-700 pt-2">
                                <div class="flex featured-post__credentials--left items-center">
                                    <div>{{ favoritePost.author ? favoritePost.author : 'Coral Club'}}</div>
                                </div>
                                <div class="flex items-center featured-post__credentials--right">
                                    <img src="../assets/img/time.svg">
                                    <div class="pl-2 text-sm">{{ favoritePost.date }}</div>
                                    <img class="ml-10" src="../assets/img/views.svg">
                                    <div class="pl-2 text-sm">{{ favoritePost.views }}</div>
                                </div>
                            </div>
                        </div>
                </router-link>
            </article>

            <!-- hot posts -->
            <section class="grid grid-cols-1 gap-3 lg1024:grid-cols-2 lg1024:w-full pb-6">
                <article class="w-full mt-2" v-for="(post, index) in hotPosts" :key="post.id">
                    <router-link :to="{ name: 'Post', params: { id: post.id, code: post.code }}" :class="{'mt-8': index > 2}" class="flex flex-col h-full">
                            <div class="flex flex-col">
                                <LazyImage :imageUrl="`https://ru.coral.club/${post.previewImageUrl}`" :classes="['image-container__hot-post']" :alt="post.name"/>
                                <div class="mt-6 font-robotoMedium text-2xl">{{ post.name }}</div>
                            </div>
                                <p class="mt-2 pt-2 pr-2 pb-6" v-html="post.preview_text.length > 160 ? post.preview_text.substring(0, 160) + '...' : post.preview_text"></p>
                                <div class="pt-4 pb-4 border-t border-themeGrayLight mr-2 flex justify-between items-center w-full mt-auto">
                                    <p class="font-robotoMedium text-sm">{{ post.author ? post.author : 'Coral Club' }}</p>
                                    <div class="flex items-center">
                                        <img src="../assets/img/time-gray.svg">
                                        <p class="text-sm text-themeBlackLight pl-2">{{ post.date }}</p>
                                    </div>
                                </div>
                    </router-link>
                </article>
            </section>
            <article v-for="(post, index) in regularPosts" :key="post.id" class="w-full lg1024:border-t lg1024:border-themeGrayLight pt-4 xl1280:pt-8" :class="[{'mt-4': index > 0}, {'xl1280:mt-8': index > 0}]">
                <router-link :to="{ name: 'Post', params: { id: post.id, code: post.code }}" v-if="!post.isFavorite && !post.isHot">
                        <div class="grid grid-cols-1 w-full lg1024:grid-cols-3">
                            <LazyImage  v-if="post.previewImageUrl" :imageUrl="`https://ru.coral.club/${post.previewImageUrl}`" :classes="['image-container__row-post']" :alt="post.name" class="xl1920:min-h-full"/>
                            <div class="flex flex-col justify-between col-span-2" :class="[{'lg1024:pl-4 ': post.previewImageUrl}, {'col-span-3': !post.previewImageUrl}]">
                                <div class="text-2xl font-robotoMedium w-3/4 mt-6 lg1024:mt-0 lg1024:text-xl"> {{ post.name }}</div>
                                <p class="pt-2 mt-2" v-html="post.preview_text.length > 160 ? post.preview_text.substring(0, 160) + '...' : post.preview_text"></p>
                                <div class="mt-8 border-t border-themeGrayLight flex justify-between items-center pt-4">
                                    <p class="font-robotoMedium text-sm">{{ post.author ? post.author : 'Coral Club' }}</p>
                                    <div class="flex items-center">
                                        <img src="../assets/img/time-gray.svg">
                                        <p class="text-sm text-themeBlackLight pl-2">{{ post.date }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </router-link>
            </article>

        </div>



        <!-- layout rows -->
        <div v-if="layout === 'rows'" class="flex w-full flex-wrap mt-6 lg1024:pr-17">
            <article v-for="(post, index) in regularPosts" :key="post.id" class="w-full lg1024:border-t lg1024:border-themeGrayLight pt-4 xl1280:pt-8" :class="[{'mt-4': index > 0}, {'xl1280:mt-8': index > 0}]">

                <router-link :to="{ name: 'Post', params: { id: post.id, code: post.code }}">
                        <div class="grid grid-cols-1 w-full lg1024:grid-cols-3">
                            <LazyImage  v-if="post.previewImageUrl" :imageUrl="`https://ru.coral.club/${post.previewImageUrl}`" :placeholder="'sm'" :classes="['image-container__row-post']" class="xl1920:min-h-full" :alt="post.name"/>
                            <div class="flex flex-col justify-between col-span-2" :class="{'lg1024:pl-4 ': post.previewImageUrl}">
                                <div class="text-2xl font-robotoMedium w-3/4 mt-6 lg1024:mt-0 lg1024:text-xl"> {{ removeTags(post.name) }}</div>
                                <p class="pt-2 mt-2" v-html="post.preview_text.length > 160 ? post.preview_text.substring(0, 160) + '...' : post.preview_text"></p>
                                <div class="mt-8 border-t border-themeGrayLight flex justify-between items-center pt-4">
                                    <p class="font-robotoMedium text-sm">{{ post.author ? post.author : 'Coral Club' }}</p>
                                    <div class="flex items-center">
                                        <img src="../assets/img/time-gray.svg">
                                        <p class="text-sm text-themeBlackLight pl-2">{{ post.date }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </router-link>
            </article>
        </div>

    </div>

</template>

<script>
  import LazyImage from "./LazyImage";
  export default {
    name: "PostsGrid",
    props: {
      layout: String,
      posts: Array,
    },
    components: {
      LazyImage
    },
    data() {
      return {
        favoritePost: {},
        hotPosts: [],
        regularPosts: [],
      }
    },
    methods: {
      isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      },
      removeTags(string) {
        return string.replace(/<\/?[^>]+>/ig, " ");
      },
      getHotPosts() {
        this.hotPosts = this.posts.filter( post => post.isHot === true);
      },
      getFeaturedPost() {
        this.favoritePost = this.posts.find( post => post.isFavorite === true);
      },
      getRegularPosts() {
        if (this.layout === 'rows') {
          this.regularPosts = this.posts;
        } else {
          this.regularPosts = this.posts.filter(post => post.isHot === false && post.isFavorite === false);
        }
      }
    },
    watch: {
      posts() {
        this.getFeaturedPost();
        this.getHotPosts();
        this.getRegularPosts();
      }
    },
    beforeMount() {
      this.getFeaturedPost();
      this.getHotPosts();
      this.getRegularPosts();
    }
  }
</script>

<style>
    .posts-grid h1, .posts-grid h2, .posts-grid h3, .posts-grid h4, .posts-grid h5, .posts-grid h6 {
        line-height: 1.25em;
    }
    .image-container__featured-post {
        background: linear-gradient(180deg,transparent 60%,#000) !important;
    }

    .image-container__featured-post img {
        position:relative;
        z-index: -1;
    }

    .featured-post__heading {
        position: absolute;
        color: #FFFFFF;
        bottom: 6.5rem;
        padding-left: 2.5rem;
    }
    .featured-post__credentials-container {
        padding: 0 2.5rem;
        position: absolute;
        bottom: 0;
    }
    .featured-post__credentials {
        color: #FFFFFF;
        padding: 1rem 0 1.5rem 0;
        border-top: 1px solid rgba(255, 255, 255, 0.75);
    }

    .featured-post__credentials--right {
        margin-left: auto;
    }


    @media only screen and (max-width: 767px) {

        .featured-post__heading {
            bottom: 1.5rem;
            padding-left: 1.5rem;
            padding-right: 1.5rem;
        }
    }

    @media only screen and (max-width: 449px) {
        .image-container__featured-post, .image-container__hot-post, .image-container__row-post {
            height: 205px;
        }
    }

    @media only screen and (min-width: 450px) and (max-width: 639px) {
        .image-container__featured-post, .image-container__hot-post, .image-container__row-post {
            height: 280px;
        }
    }


    @media only screen and (min-width: 640px) and (max-width: 767px) {
        .image-container__featured-post, .image-container__hot-post, .image-container__row-post {
            height: 310px;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 1023px) {
        .image-container__featured-post, .image-container__hot-post, .image-container__row-post {
            height: 367px;
        }
    }

    @media only screen and (min-width: 1024px) and (max-width: 1279px) {
        .image-container__featured-post {
            height: 360px;
        }
        .image-container__hot-post {
            height: 175px;
        }
        .image-container__row-post {
            height: 125px;
        }
    }

    @media only screen and (min-width: 1280px) and (max-width: 1439px)  {
        .image-container__featured-post {
            height: 430px;
        }
        .image-container__hot-post {
            height: 230px !important;
        }
        .image-container__row-post {
            height: 150px;
        }
    }

    @media only screen and (min-width: 1440px) and (max-width: 1919px)  {
        .image-container__featured-post {
            height: 475px;
        }
        .image-container__hot-post {
            height: 280px;
        }
        .image-container__row-post {
            height: 165px;
        }
    }

    @media only screen and (min-width: 1919px) and (max-width: 2499px) {
        .image-container__featured-post {
            height: 597px;
        }

        .image-container__hot-post {
            height: 295px;
        }
        .image-container__row-post {
            height: 210px;
        }
    }

    @media only screen and (min-width: 2500px) {
        .image-container__featured-post {
            height: 567px;
        }
        .image-container__hot-post {
            height: 280px;
        }
        .image-container__row-post {
            height: 200px;
        }
    }


</style>
